import { buildDefaultDataProperty } from '@bingads-webui-campaign-react/ui-generator';

export const buildSchema = options => ({
  separatorStyles: {
    marginBottom: 20,
  },
  shopping: {
    type: 'panel',
    header: {
      title: _TL_('Shopping settings'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onShoppingHeaderActionClick,
      },
    },
    components: {
      campaignName: buildDefaultDataProperty({
        // TODO: why not use type?
        label: _TL_('Campaign name'),
        dynamicProps: props => props.campaignName,
      }),
      conversionGoals: {
        type: 'conversion-goals',
        dynamicProps: props => props.conversionGoals,
      },
      hd1: {
        type: 'horizontal-divider',
      },
      store: {
        type: 'store',
        dynamicProps: props => props.store,
      },
      feeds: {
        type: 'feeds',
        dynamicProps: props => props.feeds,
      },
      localInventory: {
        type: 'local-inventory',
        dynamicProps: props => props.localInventory,
      },
      productCollections: {
        type: 'product-collections',
        dynamicProps: props => props.productCollections,
      },
      hd2: {
        type: 'horizontal-divider',
      },
      products: {
        type: 'products',
        dynamicProps: props => props.products,
      },
    },
  },
  targeting: {
    type: 'panel',
    header: {
      title: _TL_('Targeting'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onTargetingHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      adGroupName: buildDefaultDataProperty({
        label: _TL_('Ad group name'),
        dynamicProps: props => props.adGroupName,
      }),
      hd1: {
        type: 'horizontal-divider',
      },
      locationTargeting: {
        type: 'location-targeting',
        dynamicProps: props => props.locationTargeting,
      },
      genderTargeting: {
        type: 'gender-targeting',
        dynamicProps: props => props.genderTargeting,
      },
      ageRangeTargeting: {
        type: 'age-range-targeting',
        dynamicProps: props => props.ageRangeTargeting,
      },
      // PT is hidden until backend algo is ready
      // predictiveTargeting: {
      //   type: 'predictive-targeting',
      //   dynamicProps: props => props.predictiveTargeting,
      // },
      hd2: {
        type: 'horizontal-divider',
      },
      startEndDates: {
        type: 'start-end-dates',
        dynamicProps: props => props.startEndDates,
      },
      adSchedule: {
        type: 'ad-schedule',
        dynamicProps: props => props.adSchedule,
      },
      adDistribution: {
        type: 'ad-distribution',
        dynamicProps: props => props.adDistribution,
      },
    },
  },
  budgetBid: {
    type: 'panel',
    header: {
      title: _TL_('Budget & bids'),
      actionButton: {
        label: _TL_('Edit'),
        iconName: 'Edit',
        ariaLabel: _TL_('Edit'),
        onClick: options.onBudgetBidHeaderActionClick,
      },
    },
    components: {
      separatorStyles: {
        marginBottom: 8,
      },
      budget: {
        type: 'budget',
        dynamicProps: props => props.budget,
      },
      bidStrategy: {
        type: 'bid-strategy',
        dynamicProps: props => props.bidStrategy,
      },
      bidValue: {
        type: 'bid-value',
        dynamicProps: props => props.bidValue,
      },
    },
  },
});
